<mat-dialog-content>
    <button type="button" (click)="close()" class="close-button" mat-icon-button tabindex="-1">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
    <article [article]="article"></article>
</mat-dialog-content>